/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Nav_Comingsoon1Inputs */

const en_nav_comingsoon1 = /** @type {(inputs: Nav_Comingsoon1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} - Coming soon!`)
};

const ja_nav_comingsoon1 = /** @type {(inputs: Nav_Comingsoon1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} - 未実装!`)
};

const fr_nav_comingsoon1 = /** @type {(inputs: Nav_Comingsoon1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} - Bientôt disponible !`)
};

const de_nav_comingsoon1 = /** @type {(inputs: Nav_Comingsoon1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} - Bald verfügbar!`)
};

/**
* | output |
* | --- |
* | "{label} - Coming soon!" |
*
* @param {Nav_Comingsoon1Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
const nav_comingsoon1 = /** @type {((inputs: Nav_Comingsoon1Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Comingsoon1Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_comingsoon1(inputs)
	if (locale === "ja") return ja_nav_comingsoon1(inputs)
	if (locale === "fr") return fr_nav_comingsoon1(inputs)
	return de_nav_comingsoon1(inputs)
});
export { nav_comingsoon1 as "nav_comingSoon" }